import React, { useEffect } from "react";
import "./temario.css";

export default function Modal({ isOpen, onClose, children }) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="40" height="40" viewBox="0 0 40 40" xmlns="https://www.w3.org/2000/svg">
            <path d="M10 10 L30 30 M30 10 L10 30" stroke="white" strokeWidth="6" strokeLinecap="round"/>
          </svg>
        </button>
        <div className="modal-body">
            {children}
        </div>
      </div>
    </div>
  );
}